import { ProfileDropdownController } from './profile-dropdown.controller';
import OrgSwitchConfirmModal from '../../modals/org-switch-confirm/org-switch-confirm';
import 'angucomplete-alt';

import * as angular from 'angular';
import * as template from './profile-dropdown.html';

function ProfileDropdown() {
    return {
        scope: {},
        restrict: 'E',
        template: template,
        controller: ProfileDropdownController,
        controllerAs: 'ctrl',
        bindToController: {
            state: '='
        }
    };
}

export default angular
    .module('spsng.components.appProfileDropdown', ['angucomplete-alt', OrgSwitchConfirmModal])
    .directive('profileDropdown', ProfileDropdown)
    .name;
